export default __webpack_public_path__ + "static/media/moreAccessoriesActive.98b3bc76.svg";